import { ReactNode } from 'react';
import { page } from './SettingsPageLayout.module.css';

interface SettingsPageLayoutProps {
    children: ReactNode;
}

export const SettingsPageLayout = ({ children }: SettingsPageLayoutProps) => {
    return <div className={page}>{children}</div>;
};
